const Webex = require("webex");


const urlParams = new URLSearchParams(window.location.search);
const consultId = urlParams.get('consult_id');
const patientId = urlParams.get('patient_id');
const doctorId = urlParams.get('doctor_id');
const database = urlParams.get('db');
const doctorName = urlParams.get('doctor_name'); // Nome do médico
const patientName = urlParams.get('patient_name'); // Nome do paciente


console.log = function () {};
console.error = function () {};
console.warn = function () {}; 

let isMuted = false;           // Estado do microfone
let isCameraOn = true;         // Estado da câmera
var doctorSocket = null;
var patientSocket = null;
var webex;
var meetings;
var isUnregistered = false; // Flag para evitar múltiplas tentativas de desregistro
var currentMeeting = null;     // Referência da reunião atual
var microphoneStream = null;   // Stream do microfone
var cameraStream = null;       // Stream da câmera
var currentDoctorData = null;  // Dados do médico atual
var currentPatientData = null; // Dados do paciente atual
var isWebexReady = false;      // Flag para controlar se o Webex está pronto
var consultationStartTime = null; // Tempo de início da consulta
var consultationEndTime = null;   // Tempo de fim da consulta

// Função centralizada para desregistrar meetings de forma segura
async function safeUnregisterMeeting() {
  if (isUnregistered || !meetings) {
    return;
  }
  
  try {
    isUnregistered = true;
    await meetings.unregister();
    console.log("Reunião desregistrada com sucesso");
  } catch (error) {
    console.error("Erro ao desregistrar reunião:", error);
  }
}

// Função para desregistrar de forma síncrona em situações críticas
function syncUnregisterMeeting() {
  if (isUnregistered || !meetings) {
    return;
  }
  
  try {
    isUnregistered = true;
    // Chamada síncrona para situações onde não podemos aguardar promises
    meetings.unregister();
    console.log("Reunião desregistrada sincronamente");
  } catch (error) {
    console.error("Erro ao desregistrar reunião sincronamente:", error);
  }
}

// Função de Toggle do Microfone
async function toggleMicrophone() {
  console.log('toggleMicrophone chamado - estado atual:', { 
    isMuted, 
    currentMeeting: !!currentMeeting, 
    microphoneStream: !!microphoneStream 
  });
  
  if (!microphoneStream || !microphoneStream.inputStream) {
    console.warn('Stream do microfone não disponível');
    return;
  }

  try {
    const audioTracks = microphoneStream.inputStream.getAudioTracks();
    console.log('Audio tracks encontradas:', audioTracks.length);
    
    if (audioTracks.length > 0) {
      if (isMuted) {
        // Desmutar microfone
        audioTracks.forEach(track => track.enabled = true);
        isMuted = false;
        updateMicrophoneButton();
        console.log('Microfone desmutado');
      } else {
        // Mutar microfone
        audioTracks.forEach(track => track.enabled = false);
        isMuted = true;
        updateMicrophoneButton();
        console.log('Microfone mutado');
      }
    } else {
      console.warn('Nenhuma track de áudio encontrada');
    }
  } catch (error) {
    console.error('Erro ao alternar microfone:', error);
  }
}

// Função de Toggle da Câmera
async function toggleCamera() {
  console.log('toggleCamera chamado - estado atual:', { 
    isCameraOn, 
    currentMeeting: !!currentMeeting, 
    cameraStream: !!cameraStream 
  });
  
  if (!cameraStream || !cameraStream.inputStream) {
    console.warn('Stream da câmera não disponível');
    return;
  }

  try {
    const videoTracks = cameraStream.inputStream.getVideoTracks();
    console.log('Video tracks encontradas:', videoTracks.length);
    
    if (videoTracks.length > 0) {
      if (!isCameraOn) {
        // Ligar câmera
        videoTracks.forEach(track => track.enabled = true);
        document.getElementById("self-view").srcObject = cameraStream.inputStream;
        isCameraOn = true;
        updateCameraButton();
        console.log('Câmera ligada');
      } else {
        // Desligar câmera
        videoTracks.forEach(track => track.enabled = false);
        isCameraOn = false;
        updateCameraButton();
        console.log('Câmera desligada');
      }
    } else {
      console.warn('Nenhuma track de vídeo encontrada');
    }
  } catch (error) {
    console.error('Erro ao alternar câmera:', error);
  }
}

// Função de Atualização Visual - Microfone
function updateMicrophoneButton() {
  const button = document.getElementById("mute-audio");
  const icon = button.querySelector('i');
  
  if (isMuted) {
    button.classList.remove('bg-gray-600', 'hover:bg-gray-700');
    button.classList.add('bg-red-500', 'hover:bg-red-600');
    icon.classList.remove('ph-microphone');
    icon.classList.add('ph-microphone-slash');
  } else {
    button.classList.remove('bg-red-500', 'hover:bg-red-600');
    button.classList.add('bg-gray-600', 'hover:bg-gray-700');
    icon.classList.remove('ph-microphone-slash');
    icon.classList.add('ph-microphone');
  }
}

// Função de Atualização Visual - Câmera
function updateCameraButton() {
  const button = document.getElementById("mute-video");
  const icon = button.querySelector('i');
  
  if (!isCameraOn) {
    button.classList.remove('bg-gray-600', 'hover:bg-gray-700');
    button.classList.add('bg-red-500', 'hover:bg-red-600');
    icon.classList.remove('ph-video-camera');
    icon.classList.add('ph-video-camera-slash');
  } else {
    button.classList.remove('bg-red-500', 'hover:bg-red-600');
    button.classList.add('bg-gray-600', 'hover:bg-gray-700');
    icon.classList.remove('ph-video-camera-slash');
    icon.classList.add('ph-video-camera');
  }
}

// Função para atualizar informações do médico na interface
function updateDoctorInfo(doctorData) {
  console.log('🔄 Atualizando interface com dados do médico:', doctorData);
  
  // Atualizar título da página
  if (doctorData.name) {
    document.title = `Telemedicina - ${doctorData.name}`;
  }
  
  // Você pode adicionar elementos na interface para mostrar o nome
  // Por exemplo, criar um elemento para mostrar o nome do médico
  const doctorNameElement = document.getElementById('doctor-name');
  if (doctorNameElement) {
    doctorNameElement.textContent = doctorData.name || 'Médico';
  }
  
  // Armazenar dados para uso posterior (ex: no Webex)
  window.currentDoctorName = doctorData.name || 'Médico';
  
  console.log('✅ Interface atualizada com nome:', doctorData.name);
}

function updatePatientInfo(patientData) {
  console.log('🔄 Atualizando interface com dados do paciente:', patientData);
  
  // Atualizar elemento do nome do paciente
  const patientNameElement = document.getElementById('patient-name');
  if (patientNameElement) {
    patientNameElement.textContent = patientData.name || 'Paciente';
  }
  
  // Armazenar dados para uso posterior
  window.currentPatientName = patientData.name || 'Paciente';
  
  console.log('✅ Interface atualizada com nome do paciente:', patientData.name);
}

// Função para controlar o estado da sala de consulta
function enableMeetingRoom() {
  console.log('🚀 Habilitando sala de consulta - Webex pronto!');
  
  const loadingState = document.getElementById('loading-state');
  const destinationForm = document.getElementById('destination');
  
  // Mostrar feedback de sucesso temporariamente
  if (loadingState) {
    loadingState.innerHTML = `
      <div class="flex flex-col items-center gap-4">
        <div class="flex items-center gap-3 px-6 py-4 bg-green-500/80 text-white rounded-xl pulse-success">
          <i class="text-2xl ph-fill ph-check-circle"></i>
          <span class="text-lg font-medium">Sala pronta!</span>
        </div>
        <p class="text-white/70 text-sm">Você já pode iniciar a consulta</p>
      </div>
    `;
    
    // Após 2 segundos, esconder loading e mostrar botão
    setTimeout(() => {
      if (loadingState) {
        loadingState.style.display = 'none';
      }
      
      if (destinationForm) {
        destinationForm.classList.remove('hidden');
        destinationForm.classList.add('animate-fade-in');
      }
    }, 2000);
  }
  
  // Marcar como pronto
  isWebexReady = true;
  
  console.log('✅ Sala de consulta habilitada com sucesso!');
}

// Função para mostrar feedback de erro
function showMeetingError(message) {
  console.error('❌ Erro na sala de consulta:', message);
  
  const loadingState = document.getElementById('loading-state');
  if (loadingState) {
    loadingState.innerHTML = `
      <div class="flex flex-col items-center gap-4">
        <div class="flex items-center gap-3 px-6 py-4 bg-red-500/80 text-white rounded-xl">
          <i class="text-2xl ph-fill ph-warning-circle"></i>
          <span class="text-lg font-medium">Erro ao preparar sala</span>
        </div>
        <p class="text-white/70 text-sm text-center">${message}</p>
        <button onclick="location.reload()" class="px-4 py-2 bg-white/20 text-white rounded-lg hover:bg-white/30 transition-colors">
          Tentar novamente
        </button>
      </div>
    `;
  }
}

// Função para mostrar modal de confirmação
function showHangupConfirmation() {
  console.log('🤔 Mostrando confirmação de encerramento');
  const modal = document.getElementById('hangup-confirmation');
  if (modal) {
    modal.classList.remove('hidden');
  }
}

// Função para esconder modal de confirmação
function hideHangupConfirmation() {
  console.log('❌ Cancelando encerramento');
  const modal = document.getElementById('hangup-confirmation');
  if (modal) {
    modal.classList.add('hidden');
  }
}

// Função para calcular duração da consulta
function getConsultationDuration() {
  if (!consultationStartTime) return 'Duração não disponível';
  
  const endTime = consultationEndTime || new Date();
  const durationMs = endTime - consultationStartTime;
  const minutes = Math.floor(durationMs / 60000);
  const seconds = Math.floor((durationMs % 60000) / 1000);
  
  return `Duração: ${minutes}min ${seconds}s`;
}

// Função para encerrar consulta (após confirmação)
async function performHangup() {
  console.log('🔴 Encerrando consulta confirmada pelo usuário');
  
  // Registrar tempo de fim
  consultationEndTime = new Date();
  
  // Esconder modal de confirmação
  hideHangupConfirmation();
  
  // Esconder controles da reunião
  document.getElementById("doctor-video").classList.add("hidden");
  document.getElementById("hangup").classList.add("hidden");
  document.getElementById("mute-audio").classList.add("hidden");
  document.getElementById("mute-video").classList.add("hidden");
  
  // Executar encerramento técnico
  await closeSockets();
  await safeUnregisterMeeting();
  if (currentMeeting) {
    await currentMeeting.leave();
  }
  
  // Mostrar tela de encerramento com feedback rico
  showConsultationEndedScreen();
}

// Função para mostrar tela de consulta encerrada
function showConsultationEndedScreen() {
  console.log('✅ Mostrando tela de consulta encerrada');
  
  // Atualizar duração
  const durationElement = document.getElementById('consultation-duration');
  if (durationElement) {
    durationElement.textContent = getConsultationDuration();
  }
  
  // Mostrar tela
  const closedMeeting = document.getElementById('closed-meeting');
  if (closedMeeting) {
    closedMeeting.classList.remove('hidden');
  }
}


// Função para recarregar apenas o iframe (não a página pai)
function reloadIframe() {
  console.log('🔄 Recarregando iframe');
  
  // Recarregar apenas o conteúdo do iframe
  window.location.reload();
}

async function initializeWebex() {
  try {
    // Buscar dados do médico primeiro
    const doctorData = await getDoctorData(doctorId, database);
    console.log('👨‍⚕️ Dados do médico:', doctorData);
    
    // Buscar dados do paciente
    const patientData = await getPatientData(patientId, database);
    console.log('👤 Dados do paciente:', patientData);
    
    // Armazenar dados globalmente
    currentDoctorData = doctorData;
    currentPatientData = patientData;
    
    // Atualizar interface com nomes
    updateDoctorInfo(doctorData);
    updatePatientInfo(patientData);
    
    const myAccessToken = await getAccessToken(doctorId, database);

    webex = Webex.init({
      credentials: {
        access_token: myAccessToken,
      },
      // Tentar sobrescrever configurações de display
      config: {
        meetings: {
          displayName: "Médico", // Nome genérico
          enableDisplayNameOverride: true
        }
      }
    });

    meetings = webex.meetings;
    webex.config.logger.level = "debug";

    await meetings.register();

    // Múltiplos event listeners para garantir desregistro em várias situações
    
    // 1. Antes da página ser fechada (mais tempo para executar)
    window.addEventListener("beforeunload", (event) => {
      syncUnregisterMeeting();
      console.log("Reunião desregistrada ao sair da página (beforeunload).");
    });

    // 2. Quando a página está sendo descarregada (backup do beforeunload)
    window.addEventListener("unload", (event) => {
      syncUnregisterMeeting();
      console.log("Reunião desregistrada ao descarregar página (unload).");
    });


    // 5. Quando há desconexão de rede
    window.addEventListener("offline", async () => {
      await safeUnregisterMeeting();
      console.log("Reunião desregistrada - conexão perdida.");
    });

    // 6. Quando há mudança no foco da janela (perda de foco pode indicar fechamento)
    let focusTimer;

    window.addEventListener("focus", () => {
      if (focusTimer) {
        clearTimeout(focusTimer);
        focusTimer = null;
      }
    });

    // 7. Tratamento para erros não capturados que podem indicar problemas críticos
    window.addEventListener("error", async (event) => {
      console.error("Erro crítico detectado:", event.error);
      await safeUnregisterMeeting();
      console.log("Reunião desregistrada devido a erro crítico.");
    });

    // 8. Tratamento para promises rejeitadas não capturadas
    window.addEventListener("unhandledrejection", async (event) => {
      console.error("Promise rejeitada não tratada:", event.reason);
      await safeUnregisterMeeting();
      console.log("Reunião desregistrada devido a promise rejeitada.");
    });

    console.log("Webex inicializado com sucesso!");
    
    // Habilitar sala de consulta após inicialização completa
    enableMeetingRoom();

  } catch (error) {
    console.error("Erro ao inicializar o Webex:", error);
    
    // Mostrar erro para o usuário
    showMeetingError("Falha na conexão. Verifique sua internet e tente novamente.");
    
    // Tentar desregistrar mesmo em caso de erro na inicialização
    await safeUnregisterMeeting();
  }
}

function resampleAudioBuffer(inputBuffer, originalSampleRate, targetSampleRate) {
  const ratio = originalSampleRate / targetSampleRate;
  const outputLength = Math.ceil(inputBuffer.length / ratio);
  const resampledBuffer = new Float32Array(outputLength);

  for (let i = 0; i < outputLength; i++) {
    const sourceIndex = i * ratio;
    const intSourceIndex = Math.floor(sourceIndex);
    const fraction = sourceIndex - intSourceIndex;

    const nextIndex = intSourceIndex + 1 < inputBuffer.length ? intSourceIndex + 1 : intSourceIndex;
    resampledBuffer[i] = (1 - fraction) * inputBuffer[intSourceIndex] + fraction * inputBuffer[nextIndex];
  }

  return resampledBuffer;
}

function handleAudioStreamDoctor(stream) {
  doctorSocket = new WebSocket('wss://doctor-stream.doutor-ai.com:8888/out');
  websocket = doctorSocket;
  doctorSocket.onopen = () => {
    console.log('WebSocket connection opened doctor');
    const urlParams = new URLSearchParams(window.location.search);

      // Extraindo os parâmetros da URL
      const consultId = urlParams.get('consult_id');
      const patientId = urlParams.get('patient_id');
      const doctorId = urlParams.get('doctor_id');
      const database = urlParams.get('db');

    const initialMessage = {
      type: 'start',
      consult_id: consultId,
      patient_id: patientId,
      doctor_id: doctorId,
      db: database,
      timestamp: new Date().toISOString(),
      additionalInfo: 'Informações adicionais'
    };

    doctorSocket.send(JSON.stringify(initialMessage));
    console.log('Initial JSON message sent:', initialMessage);

    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    const mediaStreamSource = audioContext.createMediaStreamSource(stream);

    const scriptProcessor = audioContext.createScriptProcessor(4096, 1, 1);  // Reduzido o tamanho do buffer
    mediaStreamSource.connect(scriptProcessor);
    scriptProcessor.connect(audioContext.destination);

    scriptProcessor.onaudioprocess = (audioProcessingEvent) => {
      const inputBuffer = audioProcessingEvent.inputBuffer.getChannelData(0);
      const resampledBuffer = resampleAudioBuffer(inputBuffer, audioContext.sampleRate, 16000);

      if (doctorSocket.readyState === WebSocket.OPEN) {
        const int16Array = new Int16Array(resampledBuffer.length);
        for (let i = 0; i < resampledBuffer.length; i++) {
          int16Array[i] = Math.min(1, Math.max(-1, resampledBuffer[i])) * 0x7FFF;
        }
        doctorSocket.send(int16Array);
        console.log('Raw audio data sent to WebSocket');
      } else {
        console.warn('WebSocket not open. ReadyState:', doctorSocket.readyState);
      }
    };
  };

  doctorSocket.onerror = (error) => {
    console.error('WebSocket error:', error);
  };

  doctorSocket.onclose = async () => {
    await safeUnregisterMeeting();
    console.log('WebSocket connection closed - reunião desregistrada');
  };
}
function handleAudioStreamPatient(stream) {
  patientSocket = new WebSocket('wss://patient-stream.doutor-ai.com:7777/out');
  websocket = patientSocket;
  patientSocket.onopen = () => {
    console.log('WebSocket connection opened');
    const urlParams = new URLSearchParams(window.location.search);

    // Extraindo os parâmetros da URL
    const consultId = urlParams.get('consult_id');
    const patientId = urlParams.get('patient_id');
    const doctorId = urlParams.get('doctor_id');
    const database = urlParams.get('db');

    const initialMessage = {
      type: 'start',
      consult_id: consultId,
      patient_id: patientId,
      doctor_id: doctorId,
      db: database,
      //bot_id: "homolog",
      timestamp: new Date().toISOString(),
      additionalInfo: 'Informações adicionais'
    };

    patientSocket.send(JSON.stringify(initialMessage));
    console.log('Initial JSON message sent:', initialMessage);

    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    const mediaStreamSource = audioContext.createMediaStreamSource(stream);

    const scriptProcessor = audioContext.createScriptProcessor(4096, 1, 1);  // Reduzido o tamanho do buffer
    mediaStreamSource.connect(scriptProcessor);
    scriptProcessor.connect(audioContext.destination);

    scriptProcessor.onaudioprocess = (audioProcessingEvent) => {
      const inputBuffer = audioProcessingEvent.inputBuffer.getChannelData(0);
      const resampledBuffer = resampleAudioBuffer(inputBuffer, audioContext.sampleRate, 16000);

      if (patientSocket.readyState === WebSocket.OPEN) {
        const int16Array = new Int16Array(resampledBuffer.length);
        for (let i = 0; i < resampledBuffer.length; i++) {
          int16Array[i] = Math.min(1, Math.max(-1, resampledBuffer[i])) * 0x7FFF;
        }
        patientSocket.send(int16Array);
        console.log('Raw audio data sent to WebSocket');
      } else {
        console.warn('WebSocket not open. ReadyState:', patientSocket.readyState);
      }
    };
  };

  patientSocket.onerror = (error) => {
    console.error('WebSocket error:', error);
  };

  patientSocket.onclose = async () => {
    await meetings.unregister();
    console.log('WebSocket connection closed');
  };
}

async function bindMeetingEvents(meeting) {
  meeting.on("error", (err) => {
    console.error(err);
  });
  meeting.on("self:lobbyWaiting", (person) => {
    if (!person) {
      return;
    }
    console.log("person", person);
  });

  meeting.on("media:ready", (media) => {
    if (!media) {
      return;
    }
    if (media.type === "remoteVideo") {
      document.getElementById("remote-view-video").srcObject = media.stream;
    }
    if (media.type === "remoteAudio") {
      document.getElementById("remote-view-audio").srcObject = media.stream;
      const audioTracks = media.stream.getAudioTracks();
      if (audioTracks.length > 0) {
        console.log('Audio track found:', audioTracks[0]);
        handleAudioStreamPatient(media.stream);
        const audioElement = document.createElement('audio');
        audioElement.srcObject = media.stream;
        audioElement.play()
        audioElement.muted = true;
        audioElement.style.display = 'none';
      } else {
        console.log('No audio tracks found in the MediaStream');
      }
    }
  });

  meeting.on("media:stopped", (media) => {
    if (media.type === "remoteVideo") {
      document.getElementById("remote-view-video").srcObject = null;
    }
    if (media.type === "remoteAudio") {
      document.getElementById("remote-view-audio").srcObject = null;
    }
  });

  document.getElementById("hangup").addEventListener("click", () => {
    // Mostrar modal de confirmação ao invés de encerrar diretamente
    showHangupConfirmation();
  });
}

async function closeSockets() {
  if (doctorSocket) {
    doctorSocket.close();
  }
  if (patientSocket) {
    patientSocket.close();
  }
  // Garantir desregistro também ao fechar sockets
  await safeUnregisterMeeting();
}

async function joinMeeting(meeting) {
  currentMeeting = meeting;  // Armazenar referência
  
  // Criar streams
  microphoneStream = await meetings.mediaHelpers.createMicrophoneStream({
    echoCancellation: true,
    noiseSuppression: true,
  });
  console.log("microphoneStream", microphoneStream.inputStream);
  handleAudioStreamDoctor(microphoneStream.inputStream);
  
  try {
    cameraStream = await meetings.mediaHelpers.createCameraStream({
      width: 720,
      height: 400,
    });
    document.getElementById("self-view").srcObject = cameraStream.inputStream;
  } catch (error) {
    console.warn("Erro ao criar o fluxo da câmera:", error);
  }

  // Estados iniciais
  isCameraOn = true;  // Câmera inicia ligada
  isMuted = false;    // Microfone inicia desmutado

  const meetingOptions = {
    mediaOptions: {
      allowMediaInLobby: true,
      shareAudioEnabled: false,
      shareVideoEnabled: false,
      localStreams: {
        ...(cameraStream ? { camera: cameraStream } : {}),
        microphone: microphoneStream,
      },
    },
    // Tentar esconder display name do Webex
    displayName: "", // Nome vazio para não mostrar
    showDisplayName: false, // Tentar esconder nome
  };

  await meeting.joinWithMedia(meetingOptions);
}

document.getElementById("destination").addEventListener("submit", async (event) => {
  event.preventDefault();
  
  // Verificar se o Webex está pronto antes de prosseguir
  if (!isWebexReady) {
    console.warn("⚠️ Webex ainda não está pronto. Aguarde a inicialização completa.");
    return;
  }
  
  console.log("🚀 Iniciando reunião - Webex pronto!");
  
  const urlParams = new URLSearchParams(window.location.search);
  const link = await getJoinLink(doctorId, consultId, database);
  console.log("linkMeeting", link);

  return meetings
    .create(link)
    .then(async (meeting) => {
      console.log("meeting", meeting);

      // Registrar início da consulta
      consultationStartTime = new Date();
      console.log('⏱️ Consulta iniciada às:', consultationStartTime.toLocaleTimeString());

      document.getElementById("destination").classList.add("hidden");
      document.getElementById("doctor-video").classList.remove("hidden");
      document.getElementById("hangup").classList.remove("hidden");

      // Tornar botões visíveis
      document.getElementById("mute-audio").classList.remove("hidden");
      document.getElementById("mute-video").classList.remove("hidden");

      // IMEDIATAMENTE adicionar event listeners
      document.getElementById("mute-audio").addEventListener("click", () => {
        console.log('Clique no botão mute-audio detectado');
        toggleMicrophone();
      });
      
      document.getElementById("mute-video").addEventListener("click", () => {
        console.log('Clique no botão mute-video detectado');
        toggleCamera();
      });

      await bindMeetingEvents(meeting);

      const result = await joinMeeting(meeting);

      // Inicializar estado visual dos botões
      updateMicrophoneButton();
      updateCameraButton();

      return result;
    })
    .catch(async (error) => {
      //await closeSockets();
      //await meetings.unregister();
      console.error(error);
    });
});

async function getDoctorData(doctor_id, database) {
  console.log('👨‍⚕️ Buscando dados do médico:', { doctor_id, database, doctorName });
  
  if (!doctor_id) {
    throw new Error('doctor_id é obrigatório');
  }
  
  // Se o nome foi passado na URL, usar diretamente
  if (doctorName) {
    console.log('✅ Usando nome da URL:', doctorName);
    return {
      name: decodeURIComponent(doctorName),
      email: '',
      specialty: ''
    };
  }
  
  const db = database || 'feluma';
  
  // Tentar buscar da API do DoutorAi
  const url = `https://api-feluma.doutor-ai.com/api/doctors/${doctor_id}?db=${db}`;
  console.log('🌐 URL dos dados do médico:', url);

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
    });

    console.log('📡 Response status (doctor data):', response.status);

    if (!response.ok) {
      // Se não conseguir buscar, usar dados padrão
      console.warn('⚠️ Não foi possível buscar dados do médico, usando padrão');
      return {
        name: 'Médico',
        email: '',
        specialty: ''
      };
    }

    const data = await response.json();
    console.log('👨‍⚕️ Dados do médico recebidos:', data);
    
    return data;
  } catch (error) {
    console.warn('⚠️ Erro ao buscar dados do médico:', error);
    // Retornar dados padrão em caso de erro
    return {
      name: 'Médico',
      email: '',
      specialty: ''
    };
  }
}

async function getPatientData(patient_id, database) {
  console.log('👤 Buscando dados do paciente:', { patient_id, database, patientName });
  
  if (!patient_id) {
    throw new Error('patient_id é obrigatório');
  }
  
  // Se o nome foi passado na URL, usar diretamente
  if (patientName) {
    console.log('✅ Usando nome do paciente da URL:', patientName);
    return {
      name: decodeURIComponent(patientName),
      email: '',
      age: ''
    };
  }
  
  const db = database || 'feluma';
  
  // Tentar buscar da API do DoutorAi
  const url = `https://api-feluma.doutor-ai.com/api/patients/${patient_id}?db=${db}`;
  console.log('🌐 URL dos dados do paciente:', url);

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
    });

    console.log('📡 Response status (patient data):', response.status);

    if (!response.ok) {
      console.warn('⚠️ Não foi possível buscar dados do paciente, usando padrão');
      return {
        name: 'Paciente',
        email: '',
        age: ''
      };
    }

    const data = await response.json();
    console.log('👤 Dados do paciente recebidos:', data);
    
    return data;
  } catch (error) {
    console.warn('⚠️ Erro ao buscar dados do paciente:', error);
    return {
      name: 'Paciente',
      email: '',
      age: ''
    };
  }
}

async function getAccessToken(doctor_id, database) {
  // Corrigir URL e validar parâmetros
  console.log('🔍 Obtendo token para:', { doctor_id, database });
  
  if (!doctor_id) {
    throw new Error('doctor_id é obrigatório');
  }
  
  // Usar 'feluma' como padrão se database for undefined
  const db = database || 'feluma';
  
  const url = `https://api-feluma.doutor-ai.com/webhook/bd5b939b-e870-4d76-a28c-33f49110b622?doctor_id=${doctor_id}&db=${db}`;
  console.log('🌐 URL da API:', url);

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    console.log('📡 Response status:', response.status);

    if (!response.ok) {
      throw new Error(`Erro na requisição: ${response.statusText}`);
    }

    const data = await response.json();
    console.log('🎫 Token recebido:', data.accessToken ? 'SIM' : 'NÃO');
    console.log('📄 Response completa:', data);
    
    return data.accessToken;
  } catch (error) {
    console.error('❌ Erro ao obter accessToken:', error);
    throw error;
  }
}

async function getJoinLink(doctor_id, consult_id, database) {
  // Corrigir URL e validar parâmetros
  console.log('🔗 Obtendo link para:', { doctor_id, consult_id, database });
  
  const db = database || 'feluma';
  const url = `https://api-feluma.doutor-ai.com/webhook/d54ed8fc-2053-4db3-858b-3cbc0d207f19?doctor_id=${doctor_id}&consult_id=${consult_id}&db=${db}`;
  console.log('🌐 URL do link:', url);

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    console.log('📡 Response status (link):', response.status);

    if (!response.ok) {
      throw new Error(`Erro na requisição: ${response.statusText}`);
    }

    const data = await response.json();
    console.log('🔗 Link recebido:', data.startLink ? 'SIM' : 'NÃO');
    
    return data.startLink;
  } catch (error) {
    console.error('❌ Erro ao obter link:', error);
    throw error;
  }
}

// Event listeners para os novos botões
document.addEventListener('DOMContentLoaded', () => {
  // Botão cancelar no modal de confirmação
  const cancelHangupBtn = document.getElementById('cancel-hangup');
  if (cancelHangupBtn) {
    cancelHangupBtn.addEventListener('click', hideHangupConfirmation);
  }
  
  // Botão confirmar no modal de confirmação
  const confirmHangupBtn = document.getElementById('confirm-hangup');
  if (confirmHangupBtn) {
    confirmHangupBtn.addEventListener('click', performHangup);
  }
  
  // Botão retomar consulta na tela de encerramento
  const resumeBtn = document.getElementById('resume-consultation-btn');
  if (resumeBtn) {
    resumeBtn.addEventListener('click', reloadIframe); // Usando recarregar para máxima confiabilidade
  }
});

initializeWebex();
